import React, { useState } from 'react';
import { Orders_text } from '../../../constant/Translation/OrdersText';
import { General_text } from '../../../constant/Translation/General';
import {
  file_icon,
  download_icon,
  delete_icon,
} from '../../Shared/Constant/Icons/AllIcons';

const SellerInvoice = ({
  order_details,
  setShowError,
  setError_message,
  setShowSuccess,
  setSuccess_message,
}) => {
  // Mock data - in real implementation, this would come from props or API
  const [invoices, setInvoices] = useState([
    {
      id: 1,
      name: order_details?.invoice_url?.split('/').pop(),
      size: '',
      type: '',
      uploadedBy: 'Seller',
      uploadedAt: order_details?.invoice_date,
      url: order_details?.invoice_url,
    },
  ]);

  // Handle file download
  const handleDownload = (invoice) => {
    //  make a new tab and open the url and download the file
    window.open(invoice.url, '_blank');
    return;
  };

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  // Get file type icon
  const getFileTypeIcon = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    if (['pdf'].includes(extension)) {
      return (
        <svg
          className="w-6 h-6 text-red-500"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z"
            clipRule="evenodd"
          />
        </svg>
      );
    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
      return (
        <svg
          className="w-6 h-6 text-green-500"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
            clipRule="evenodd"
          />
        </svg>
      );
    } else {
      return file_icon;
    }
  };

  return (
    <div className="w-full bg-white shadow-c-sm rounded-button p-4 sm:p-7 border-opacity-40">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-lg text-black font-semibold">
          {Orders_text.orderdetail.order_invoices}
        </h3>
        <span className="text-sm text-gray-500">
          {invoices.length}{' '}
          {invoices.length === 1
            ? Orders_text.orderdetail.invoice
            : Orders_text.orderdetail.invoices}
        </span>
      </div>

      {/* Invoices List */}
      {invoices.length > 0 ? (
        <div className="space-y-4">
          {invoices.map((invoice) => (
            <div
              key={invoice.id}
              className="border border-gray-200 rounded-button p-4 hover:shadow-md transition-shadow"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 flex-1">
                  <div className="text-primary">
                    {getFileTypeIcon(invoice.name)}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-gray-900 truncate">
                      {invoice.name}
                    </p>
                    <div className="flex items-center gap-4 text-sm text-gray-500 mt-1">
                      <span>{invoice.size}</span>
                      <span>•</span>
                      <span>
                        {Orders_text.orderdetail.uploaded_by}{' '}
                        {invoice.uploadedBy}
                      </span>
                      <span>•</span>
                      <span>{formatDate(invoice.uploadedAt)}</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => handleDownload(invoice)}
                    className="p-2 text-primary hover:text-success transition-colors"
                    title="Download"
                  >
                    {download_icon}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        /* Empty State */
        <div className="border-2 border-dashed border-gray-300 rounded-button p-8 text-center mt-5">
          <div className="flex flex-col items-center gap-4">
            <div className="text-gray-400">
              <svg
                className="w-16 h-16"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div>
              <p className="text-lg font-semibold text-gray-700 mb-2">
                {Orders_text.orderdetail.no_invoices_available}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Summary */}
      {invoices.length > 0 && (
        <div className="mt-6 pt-4 border-t border-gray-200">
          <div className="flex justify-between items-center text-sm text-gray-600">
            <span>
              {Orders_text.orderdetail.total_files}: {invoices.length}
            </span>
            <span>
              {Orders_text.orderdetail.last_updated}:{' '}
              {invoices.length > 0
                ? formatDate(invoices[0].uploadedAt)
                : 'Never'}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SellerInvoice;
